import * as React from 'react'

const SheildUser = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
    <circle cx='12' cy='10' r='3' />
    <path d='M12 13c-2.67 0-8 1.34-8 4v1h16v-1c0-2.66-5.33-4-8-4' />
  </svg>
)

export default React.memo(SheildUser)
